// extracted by mini-css-extract-plugin
export default {"melodyVideo":"JK-z","isFullWidth":"KK-z","landingPageVideo":"LK-z","play":"MK-z","iframeVideo":"NK-z","playHidden":"OK-z","fullwidth":"PK-z"};